<mat-paginator showFirstLastButtons style="justify-self: flex-end;visibility: visible;"></mat-paginator>
<div class="table-container">
  <table [dataSource]="dataSource"
    [matSortActive]="'created_on'"
    class="table user-table table-striped"
    mat-table matSort matSortDirection="asc">

    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column">
        <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell>
          <ng-container>{{column | titlecaseForWire | removeUnderscore}}</ng-container>
        </th>
        <td *matCellDef="let element;"
          mat-cell
          style="text-align: left;border:none;">
          @if (['account_name'].includes(column)) {
            {{element.attributes.account_name}}
          }
          @if (['default_dashboard'].includes(column)) {
            <select-search-component
              [api_model]="'session_state_light'"
              [classes]="'show-select-arrow fill'"
              [custom_filters]="default_dashboard_options_filter"
              (selectionChange)="updateDefaultPage(element, $event.value)"
              [value]="element.relationships.session_state.data"
              [accountId]="element.relationships.account.data.id"
              [allowAccountSelection]="false"
              [compareFunctionName]="'compareById'"
              [filter_by]="['name']"
              [stringFunction]="pagesInfoFunction">
            </select-search-component>
          }
          @if (['created_on','changed_on'].includes(column)) {
            {{element.attributes[column] | stringDate }}
          }
          @if (['created_by_name','changed_by_name'].includes(column)) {
            {{element.attributes[column]}}
          }
        </td>
      </ng-container>
    }

    <ng-container>
      <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: columns;" mat-row></tr>
    </ng-container>
  </table>
</div>
